import { runSyncAsUser } from './exec';

export const enable = (time: number = 60) => {
  runSyncAsUser('./screensaver.sh', ['enable', time]);
};

export const disable = () => {
  runSyncAsUser('./screensaver.sh', ['disable']);
};

export const update = (config: Object) => {
  if (config.screensaver) {
    enable(config.screensaver);
  } else {
    disable();
  }
};
